import { useState } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import { FaRegCalendar } from 'react-icons/fa';
import styles from './Input.module.scss';
import RadioRegister from '../RadioRegister';
import 'react-datepicker/dist/react-datepicker.css';

const DateCustomInput = ({
    register,
    onChange,
    placeholder,
    value,
    isSecure,
    id,
    onClick,
}) => {
    const ICON_COLOR = '#DAA520';
    return (
        <>
            <FaRegCalendar style={{ color: ICON_COLOR }} />
            <input
                className={styles.input}
                onChange={onChange}
                placeholder={placeholder}
                value={value}
                isSecure={isSecure}
                id={id}
                onClick={onClick}
                {...register}
            />
        </>
    );
};

const Input = (props) => {
    const { register } = props;
    const [startDate, setStartDate] = useState(new Date());

    const _render = (type) => {
        if (type === 'datepicker') {
            return (
                <>
                    <label className={styles.label}>
                        {props?.label}
                        {props?.required ? (
                            <span className={styles.requiredTextColor}>*</span>
                        ) : null}
                    </label>
                    <DatePicker
                        wrapperClassName="datePicker"
                        selected={startDate}
                        customInput={<DateCustomInput register={register} />}
                        onChange={(date) => setStartDate(date)}
                        peekNextMonth
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                    />
                    {props?.errors?.[register.name] && (
                        <span className={styles.textRequired}>
                            {props?.errors?.[register.name]?.message}
                        </span>
                    )}
                </>
            );
        } else if (type === 'radio-register') {
            return (
                <>
                    <label className={styles.label}>
                        {props?.label}
                        {props?.required ? (
                            <span className={styles.requiredTextColor}>*</span>
                        ) : null}
                    </label>
                    <div className={styles.radioRegisterWrapper}>
                        {props.items.map((key, index) => (
                            <RadioRegister
                                key={`${key}-${index}`}
                                id={`${key}-${index}`}
                                label={`${key}`}
                                value={key}
                                register={register}
                            />
                        ))}
                    </div>
                </>
            );
        } else {
            return (
                <>
                    <label
                        style={props?.styles ? props.styles.label : {}}
                        className={styles.label}
                    >
                        {props?.label}
                        {props?.required ? (
                            <span className={styles.requiredTextColor}>*</span>
                        ) : null}
                    </label>
                    <input
                        style={props?.styles ? props.styles.input : {}}
                        autoComplete="off"
                        className={styles.input}
                        placeholder={
                            props?.placeholder
                                ? props?.placeholder
                                : props.label
                        }
                        minLength={props?.minLength ? props?.minLength : ''}
                        maxLength={props?.maxLength ? props?.maxLength : ''}
                        type={props.type === 'password' ? 'password' : 'text'}
                        disabled={props?.disabled ? true : false}
                        {...register}
                    />
                    {props?.errors?.[register.name] && (
                        <span className={styles.textRequired}>
                            {props?.errors?.[register.name]?.message}
                        </span>
                    )}
                </>
            );
        }
    };

    return _render(props?.type);
};

Input.propTypes = {
    register: PropTypes.object.isRequired,
    errors: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    required: PropTypes.bool,
};

export default Input;
